import React from 'react';
import { Form } from 'react-bootstrap';

export interface ThSelectBoxModel {
  label: string;
  value: string;
  options: { value: string; label: string }[];
  required?: boolean;
  onChange: (value: string) => void;
  mb?: number;
}

function ThInputSelect({
  label,
  value,
  options,
  required,
  onChange,
  mb = 24
}: ThSelectBoxModel) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange((e.target as HTMLInputElement).value);
  };

  return (
    <Form.Group
      style={{marginBottom: `${mb}px`}}
      controlId={label.replace(/\s+/g, '')}
    >
      <Form.Label>
        {label}
        {required && <span className='text-primary'>&nbsp;*</span>}
      </Form.Label>
      <Form.Control
        className='form-select'
        as='select'
        value={value}
        required={required}
        onChange={handleChange}
      >
        <option
          value=''
          disabled
        >
          Select
        </option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  );
}

export default ThInputSelect;
